import { useState, useEffect } from 'react'
import { EditOutlined, CheckOutlined } from '@ant-design/icons'
import WeaverService from 'Services/WeaverService'
import { getFormattedAttributeValue } from './shared'

export default EditableValue = ({ value, attributeKey, type, node, InputField, saveChangesFn }) ->

  [isEditing, setIsEditing] = useState(false)
  [updatedValue, setUpdatedValue] = useState(value)

  saveChangesFn ?= (attributeKey, updateValue) ->
    dataType = node.getDataType?(attributeKey)
    node.set(attributeKey, updatedValue, { dataType })
    node.save({ commitMessage: "Updated #{ attributeKey } to #{ value }" })

  if isEditing
    <>
      <InputField
        updateValue={setUpdatedValue}
        value={updatedValue}
        attributeKey={attributeKey}
        type={type}
        node={node}
      />
      <a style={{ float: 'right' }}>
        <CheckOutlined
          data-testid="save-attr-#{ attributeKey }"
          style={{ marginLeft: '10px' }}
          onClick={ ->
            saveChangesFn(attributeKey, updatedValue)
            setIsEditing(false)
          }
        />
      </a>
    </>
  else
    <>
      <span>{ getFormattedAttributeValue(updatedValue, attributeKey, node.getDataType(attributeKey)) }</span>
      { WeaverService.userCanEdit() &&
        <a className="edit-attr-and-rel-key-icon" style={{ float: 'right' }}>
          <EditOutlined
            data-testid="edit-attr-icon-#{ attributeKey }"
            style={{ marginLeft: 10 }}
            onClick={-> setIsEditing(true)}
          />
        </a>
      }
    </>
